import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "report",
  listKey: "reports",
  itemKey: "report",
  getAll: types.GET_ALL_REPORTS,
  getAllResponse: types.GET_ALL_REPORTS_RESPONSE,
  create: types.CREATE_REPORT,
  getByIdResponse: undefined,
});
